export const ITEMS_PER_PAGE = 10;
export const DEFAULT_PAGE = 0;
export const DEFAULT_PATH_ID = 1;
export const BASE_URL = 'https://mrcamel.netlify.app';
export const ERROR_MSG =
  'Failed to fetch data, please check your API or Internet connetction';
